import React from 'react';
import Grid from '@material-ui/core/Grid';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  quantity: {
    border: 'solid 0.8px rgb(167, 159, 159)',
    borderRadius: theme.shape.borderRadius * 4,
    textAlign: 'center'
  }
});

const AddRemove = ({ classes }) => {
  return (
    <div>
      <Grid container spacing={0}>
        <Grid item xs={1} />
        <Grid item xs={10}>
          <div className={classes.quantity}>
            <div className="quantity-row">
              <Grid container spacing={8} justify="center">
                <Grid item xs={3}>
                  <IconButton
                    title="RemoveQuantity"
                    variant="outlined"
                    style={{ marginTop: 'auto', marginBottom: '13px' }}
                  >
                    <RemoveIcon />
                  </IconButton>
                </Grid>
                <Grid item xs={6}>
                  <p className="added-quantity">1</p>
                </Grid>
                <Grid item xs={3}>
                  <IconButton
                    title="AddQuantity"
                    variant="outlined"
                    style={{ marginTop: 'auto', marginBottom: '13px' }}
                  >
                    <AddIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </div>
          </div>
        </Grid>
        <Grid item xs={1} />
      </Grid>
    </div>
  );
};
export default withStyles(styles)(AddRemove);



// WEBPACK FOOTER //
// ./src/components/ItemQuantity.js